export enum AirlineWebapiErrorCodesEnum {
    Success = 0,
    GeneralError = 1,
    UserAlreadyExists = 2,
    InvalidCredentials = 3,
    AccountLockedOut = 4,
    UserDoesntExist = 5,
    PasswordAlreadyUsedInTheLast5Password = 6,
    CompanionAlreadyExist = 7,
    SessionTimeout = 8,
    MaximumCompanionLimitReached = 9
}
